/*
 * @Author: 高苏杭
 * @Date: 2023-12-12 14:39:27
 * @LastEditTime: 2023-12-12 14:39:28
 * @Description: 
 */
import TableTextareaCell from './TableTextareaCell.vue';

export default {
  install(Vue) {
    Vue.component('TableTextareaCell', TableTextareaCell);
  }
};


// WEBPACK FOOTER //
// ./src/components/TableTextareaCell/index.js